import { useSiteConfig } from "@/hooks/useSiteConfig";
import Countdown from "@/components/site/Countdown";
import { Reveal } from "@/components/site/primitives";

const CountdownBand = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-16 lg:py-20 border-b border-line" data-testid="countdown-band">
      <div className="section-shell grid gap-10 lg:grid-cols-[1fr_1.2fr] items-center">
        <Reveal>
          <div className="font-mono text-xs tracking-[0.4em] uppercase text-slate">Presale Begins</div>
          <div className="mt-3 gold-number font-semibold text-2xl sm:text-4xl" data-testid="band-presale-date">
            1 November 2026
          </div>
          <button
            onClick={() => window.dispatchEvent(new CustomEvent("jcv:scroll", { detail: "#presale" }))}
            className="mt-5 font-mono text-[11px] tracking-[0.25em] uppercase text-teal hover:text-mist transition-colors duration-300"
            data-testid="band-presale-link"
          >
            View presale section →
          </button>
        </Reveal>
        <Reveal delay={0.1}>
          <Countdown target={config.presale.startDateISO} status={config.presale.status} compact />
        </Reveal>
      </div>
    </section>
  );
};

export default CountdownBand;
